import React from 'react';

import { pageContext } from 'ctm-util-functions';
import { Page } from 'ctm-components';
import { ComponentsBuildDirector } from '../component_build_director';

/**
 * @desc builds application pages based on a schema definition
 */
class PageBuilder {

    /**
     * set up the schema model instance
     * @param {Object} schemaModel - the page schema model
     */
    constructor(schemaModel) {
        this.schemaModel = schemaModel;
    }

    /**
     build an application page based on a schema object and array of builders.
     * @param {Object} pageState - The page state.
     * @param {Object} pageSchema - Schema defining the page to be built.
     * @param {Boolean} isSSR - Flag to indicate if this page is being built on the server or the client
     * @param {Object} location - The location object from the router
     * @param {Boolean} isRedirecting - True if this build is happening during a redirect for conditional steps
     * @param {Boolean} isRouteChanged - True if this build is building a page with the same route as before
     * @returns {Node} page - the application page with appropriate inner layout and children.
     */
    build = (pageState, pageSchema, isSSR, location, isRedirecting, isRouteChanged) => {
        const { builders } = pageContext.getProps();
        const director = new ComponentsBuildDirector(builders);

        // Note: we still need to export components as a separate parameter
        // as children components need to pass in their own components
        pageContext.setProps({
            pageSchema,
            director,
            pageState,
            location: pageState.location
        });

        // @todo: can probably remove pageState from here and just use pageContext
        return (
            <Page
                pageSchema={pageSchema}
                pageState={pageState}
                isSSR={isSSR}
                location={location}
                isRedirecting={isRedirecting}
                isRouteChanged={isRouteChanged}
                key="Page"
            >
                {director.constructComponents(pageSchema.components)}
            </Page>
        );
    };

}

export { PageBuilder };
